import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ActivityPage.css';

function ActivityPage() {
  const navigate = useNavigate();

  return (
    <div className="activity-page">
      <h1 className="page-title">Активність</h1>

      {/* Навигация по разделам */}
      <nav className="activity-nav">
        <a href="#what-is-activity">Що таке активність?</a>
        <a href="#arms-exercises">Вправи для рук</a>
        <a href="#legs-exercises">Вправи для ніг</a>
        <a href="#abs-exercises">Вправи для пресу</a>
        <a href="#full-body-exercises">Вправи для всього тіла</a>
      </nav>

      {/* Что такое активность */}
      <section className="activity-section" id="what-is-activity">
        <h2>Що таке активність та навіщо вона нам потрібна?</h2>
  <p>
    Рухова активність — це будь-які форми руху, що потребують енергії, наприклад ходьба, фізична робота, фізичні вправи, заняття спортом тощо.
  </p>
  <p>
    Рухова активність потрібна нашому життю дуже сильно. Саме вона слугує підтримкою для нашого здоров'я, а саме:
  </p>
  <ul>
    <li>покращує роботу сердця, знижує ризик серцевих захворювань та інсульту;</li>
    <li>дозволяє спалювати калорії, що надає можливість підтримувати вагу у нормі;</li>
    <li>допомогає збільшити м'язову масу, зміцнити кістки;</li>
    <li>прискорює обмін речовин та роботу дихальної системи;</li>
    <li>стимулює вироблення ендорфіну, що покращує настрій та знижує рівень стресу;</li>
    <li>збільшує тривалість життя.</li>
  </ul>
  <p>
    Не забувайте приділяти увагу фізичній активності вашого організму. Навіть сама маленька активність краще, ніж повна її відсутність у вашому житті.
  </p>
      </section>

      {/* Вправи для рук */}
      <section className="activity-section" id="arms-exercises">
        <h2 className="exercise-title" >Вправи для рук</h2>

        <div className="exercise">
          <h4>Віджимання від підлоги</h4>
          <p>
            Встаньте у планку на витягнутих руках. Встановіть все своє тіло у рівну лінію, втягніть м'язи живота. Зробіть згин рук до підлоги після чого поверніться у початкове положення, випрямивши руки. Коли опускаєтесь вдихайте повітря, коли підіймаєтесь - видихайте повітря.
          </p>
          <p>Ви можете ускладнити віджимання, наприклад:</p>
          <ul>
            <li>віджимання від колін;</li>
            <li>віджимання з опорою на кулаки;</li>
            <li>віджимання з доданими рухами (хлопки);</li>
            <li>віджимання з додатковою вагою.</li>
          </ul>
          <p>
            Виконувати потрібно по 3 - 4 підходи по 8 - 12 разів. Підходи вибирайте для себе індивідуально, зважаючи на стан здоров'я та самопочуття.
          </p>
          <img
            src="/pushups.jpg"
            alt="Віджимання від підлоги"
            className="exercise-image"
          />
        </div>

        <div className="exercise">
          <h4>Підйом гантелей на біцепс</h4>
  <p>
    Взяти гантелі в руки, стоячи прямо. Повільно згинати руки в ліктях, піднімаючи гантелі до плечей, потім повільно опускати.
  </p>
  <p>
    Візьміть до рук по одній гантелі. Ноги встановіть на ширині плечей. Потрібно випрямити тулуб та напружити м'язи рук. Підніміть гантелі до плечей. Лікті не потрібно робити у перед, весь цей час ви повинні стояти струнко. На піднятті гантелей до плечей робити глибокий вдох, на спуску гантелей донизу — видих. При спуску гантелей донизу, ваші руки повинні зайняти положення біля стегон.
  </p>
  <p>
    Робити потрібно по 3 — 4 підходи по 5 — 8 разів. При виконанні вправи зважайте на своє фізичне здоров'я та самопочуття.
  </p>
  <img
    src="/bicep-curls.jpg"
    alt="Підйом гантелей на біцепс"
    className="exercise-image"
  />
</div>
      </section>

      {/* Вправи для ніг */}
      <section className="activity-section" id="legs-exercises">
        <h2 className="exercise-title" >Вправи для ніг</h2>

        <div className="exercise">
  <h4>Присідання</h4>
  <p>
    Встаньте у стійку, встановивши положення ніг на ширині плечей. Тіло повинно бути струнким. Витягніть руки перед собою та опустіться присіданням донизу, затримавшись у такому положенні не більше 1 секунди. Після чого поверніться у початкове положення. При присіданні донизу робіть глибокий видих, при піднятті тулуба догори — вдихайте повітря.
  </p>
  <p>Ви можете ускладнити виконання цієї вправи, наприклад:</p>
  <ul>
    <li>додати вагу при присіданні;</li>
    <li>виконувати присідання у вигляді пістолету (тримаючи одну з ніг піднятою);</li>
    <li>сумо присідання;</li>
    <li>виконувати напівприсідання.</li>
  </ul>
  <p>
    Виконувати потрібно по 3–4 підходи по 8–12 разів. Перед виконанням вправи зважайте на свій стан здоров'я і самопочуття.
  </p>
  <img
    src="/squats.jpg"
    alt="Присідання"
    className="exercise-image"
  />
</div>

 <div className="exercise">
  <h4>Випади вперед</h4>
  <p>
    Займіть положення стоячи, поставивши ноги на ширині стегон. Зробіть крок вперед, щоб одна нога була спереду, а інша вставши на коліно позаду. При опусканні зігніть коліна на 90 градусів. Тулуб весь цей час повинен бути рівним. Після цього поверніться у початкове положення, відштовхнувшись передньою ногою від підлоги.
    При спуску до підлоги виконуйте глибокий видих, при піднятті — вдих.
  </p>
  <p>Ви можете ускладнити виконання цієї вправи, наприклад:</p>
  <ul>
    <li>робити випади назад;</li>
    <li>випади з додатковою вагою;</li>
    <li>робити випади в бік;</li>
    <li>випади спираючись на стілець;</li>
    <li>виконувати випади зі стрибками.</li>
  </ul>
  <p>
    Виконувати потрібно по 3–4 підходи по 8–12 разів. При виконанні вправи потрібно звернути увагу на свій фізичний стан здоров'я та самопочуття.
  </p>
  <img
    src="/lunges.jpg"
    alt="Випади вперед"
    className="exercise-image"
  />
</div>

<div className="exercise">
  <h4>Місток</h4>
  <p>
    Займіть положення лежачи, розмістивши стопи на ширині стегон, ноги зігніть у колінах, ногами торкайтеся підлоги. Зробіть напругу на ноги та виштовхніть стегна догори, переконайтесь, що стегна та плечі утворюють пряму лінію. Залишіться у такому положенні не більше 1 секунди, після чого поверніться до початкового положення тіла.
  </p>
  <p>Ви можете ускладнити виконання вправи, наприклад:</p>
  <ul>
    <li>додавши навантаження при піднятті стегон;</li>
    <li>робивши місток з підняття однієї ноги догори.</li>
  </ul>
  <p>
    Виконувати потрібно по 3–4 підходи по 8–12 разів. При виконанні слідкуйте за своїм фізичним здоров'ям та самопочуттям.
  </p>
  <img
    src="/bridge.jpg"
    alt="Місток"
    className="exercise-image"
  />
</div>


      </section>

      {/* Вправи для пресу */}
      <section className="activity-section" id="abs-exercises">
        <h2 className="exercise-title" >Вправи для пресу</h2>

        <div className="exercise">
  <h4>Планка</h4>
  <p>
    Спустіться до підлоги та займіть положення планки. Руки розмістіть на ширині плечей, втягніть м'язи живота. Тулуб повинен бути рівним. Затримайтесь у такому положенні 15 секунд, у подальшому виконанні ви можете поступово збільшувати час виконання цієї вправи до 1 хвилини.
  </p>
  <p>Ви можете ускладнити виконання цієї вправи, наприклад:</p>
  <ul>
    <li>виконувати планку на колінах;</li>
    <li>виконувати похилу планку;</li>
    <li>виконувати планку з підйомом однієї з ніг;</li>
    <li>виконувати планку з підйомом рук.</li>
  </ul>
  <p>
    Виконання вправи є корисним для вашого здоров'я. При виконанні зважайте увагу на свій фізичний стан здоров'я та самопочуття.
  </p>
  <img
    src="/plank.jpg"
    alt="Планка"
    className="exercise-image"
  />
</div>


  <div className="exercise">
  <h4>Скручування</h4>
  <p>
    Займіть положення лежачи на спині, зігніть коліна і поставте стопи на підлогу. Руки покладіть за головою, напружте м'язи живота і повільно підійміть плечі від підлоги, затримайтесь у такому положенні не більше 1 секунди, після чого поверніться у початкове положення.
  </p>
  <p>Ви можете ускладнити скручування, наприклад:</p>
  <ul>
    <li>додати у виконання додаткові рухи (велосипед);</li>
    <li>виконувати зворотні скручування.</li>
  </ul>
  <p>
    Виконувати потрібно по 2–3 підходи по 8–12 разів. Під час виконання зважайте увагу на ваш фізичний стан здоров'я та самопочуття.
  </p>
  <img
    src="/crunches.jpg"
    alt="Скручування"
    className="exercise-image"
  />
</div>

<div className="exercise">
  <h4>Велосипед</h4>
  <p>
    Займіть положення лежачи на спині та зігніть ноги у колінах. Підійміть ноги догори, утворюючи кут 90 градусів. Покладіть руки за голову і по черзі тягніться ліктем до протилежного коліна, в цей час робіть рухи ногами, роблячи імітацію кручення педалей велосипеда.
  </p>
  <p>
    Виконувати потрібно по 3–4 підходи по 8–15 разів. Під час виконання зверніть увагу на фізичний стан здоров'я та самопочуття.
  </p>
  <img
    src="/bicycle-crunch.jpg"
    alt="Велосипед"
    className="exercise-image"
  />
</div>

</section>


      {/* Вправи для всього тіла */}
      <section className="activity-section" id="full-body-exercises">
        <h2 className="exercise-title" >Вправи для всього тіла</h2>

        <div className="exercise">
  <h4>Бурпі</h4>
  <p>
    Зайняти положення зігнутих ніг в колінах, спина повинна бути прямою, ступні розташовані на ширині плечей. Руки розмістити поперед стоп. З цього положення відштовхуємося ногами назад і займаємо положення для віджимання, робимо одне віджимання, зберігаючи пряму спину. Потім потрібно зробити стрибок і повернутися у початкове положення. Як тільки ви виконаєте цей етап — займіть положення присідання.
  </p>
  <p>
    Виконувати потрібно по 2–3 підходи по 6–10 разів. Під час виконання зверніть увагу на ваш фізичний стан здоров'я та самопочуття.
  </p>
  <img
    src="/burpee.jpg"
    alt="Бурпі"
    className="exercise-image"
  />
</div>


        <div className="exercise">
  <h4>Стрибки з розведенням рук і ніг (Jumping Jacks)</h4>
  <p>
    Займіть положення стоячи, ноги поставте поруч, руки вздовж тіла. Зробіть стрибок, розводячи ноги в сторони і підійміть руки над головою, щоб долоні могли торкнутися одна одної. Зробіть ще один стрибок, повертаючись у початкове положення, зводячи ноги разом і опускаючи руки вздовж тулуба донизу.
  </p>
  <p>
    Виконувати потрібно по 3–4 підходи по 8–12 разів. Під час виконання вправи зверніть увагу на фізичний стан здоров'я та самопочуття.
  </p>
  <img
    src="/jumping-jacks.jpg"
    alt="Стрибки з розведенням рук і ніг"
    className="exercise-image"
  />
</div>


      </section>

      <button className="back-button" onClick={() => navigate('/')}>На головну</button>
    </div>
  );
}

export default ActivityPage;